/**
 * Created by lenovo on 2017/5/10.
 */
import ajax from '../../ajax/'
import {ellaUrl} from 'CONFIG/path.config'
class EllaService {
    login ({data}={}) {
        return ajax({
            method: 'post',
            url: ellaUrl+'/check/login',
            body: data
        })
    }
    //子系统列表
    subsystemList({data}={}) {
        return ajax({
            method: 'post',
            url: ellaUrl+'/back/subsystem/list',
            body: data
        })
    }
    //添加或者编辑子系统同步信息
    subsystemDoAddOrUpdate({data}={}){
        return ajax({
            method: 'post',
            url: ellaUrl+'/subsystem/doAddOrUpdate',
            body: data
        })
    }
    //获取子系统编辑详情
    subsystemToUpdate(id){
        return ajax({
            method: 'get',
            url: ellaUrl+'/subsystem/toUpdate/'+id,
        })
    }
    //删除子系统
    subsystemDoDelete(id){
        return ajax({
            method: 'get',
            url: ellaUrl+'/subsystem/doDelete/'+id,
        })
    }


    //用户启用
    enableUser(id){
        return ajax({
            method:'get',
            url : ellaUrl+'/user/enable/'+id,
        })
    }
    //用户禁用
    disableUser(id){
        return ajax({
            method:'get',
            url : ellaUrl+'/user/disable/'+id,
        })
    }

    //用户添加
    addUser(){
        return ajax({
            method:'get',
            url : ellaUrl+'/user/toAdd',
        })
    }
    //GET /userextends/getByUserTypeId/{userTypeId} 根据用户类型获取对应的扩展属性
    getByUserTypeIdUser(id){
        return ajax({
            method:'get',
            url : ellaUrl+'/userextends/list/'+id,
        })
    }
    //用户新增或编辑
    saveUser({userBody}={}){
        return ajax({
            method: 'post',
            url: ellaUrl+'/user/doAddOrUpdate',
            body:userBody,
        })
    }
    //获取用户信息
    userToUpdate(id){
        return ajax({
            method:'get',
            url : ellaUrl+'/user/toUpdate/'+id,
        })
    }

    //短信查询列表
    messageLog({data}={}){
        return ajax({
            method:'post',
            url :ellaUrl+'/message/log',
            body:data,
        })
    }
    //app版本查询列表
    appversionList({data}={}){
        return ajax({
            method:'post',
            url :ellaUrl+'/appversion/getPage',
            body:data,
        })
    }
    //app版本添加或编辑
    appversionDoAddOrUpdate({data}={}){
        return ajax({
            method:'post',
            url :ellaUrl+'/appversion/doAddOrUpdate',
            body:data,
        })
    }
    //app编辑版本初始数据
    appversionToUpdate(id){
        return ajax({
            method:'get',
            url :ellaUrl+'/appversion/toUpdate/'+id,
        })
    }
    //app版本删除
    appversionDelete(id){
        return ajax({
            method:'get',
            url:ellaUrl+'/appversion/delete/'+id,
        })
    }

    //用户类型编辑初始化
    usertypeToUpdate(id){
        return ajax({
            method:'get',
            url : ellaUrl+'/usertype/toUpdate/'+id
        })
    }
    //用户类型存储
    userTypeDoAddOrUpdate({data}={}){
        return ajax({
            method:'post',
            url :ellaUrl+'/usertype/doAddOrUpdate',
            body:data,
        })
    }
    // 用户新增信息统计
    userInsertStatistics({data}={}){
        return ajax({
            method:'post',
            url :ellaUrl+'/user/insert/statistics',
            body:data,
        })
    }
    // 用户分布统计
    userProvinceStatistics(){
        return ajax({
            method:'post',
            url :ellaUrl+'/user/province/statistics',
            body:JSON.stringify({}),
        })
    }
    // 邮件查询列表
    emailLog({data}={}){
        return ajax({
            method:'post',
            url :ellaUrl+'/email/log',
            body:data,
        })
    }
}
export default new EllaService()


// WEBPACK FOOTER //
// ./modules/services/purifier/ella/ellaService.js